var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleMeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0B74BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 11.25V11.75H12.75H19.5C19.5663 11.75 19.6299 11.7763 19.6768 11.8232C19.7237 11.8701 19.75 11.9337 19.75 12C19.75 12.0663 19.7237 12.1299 19.6768 12.1768C19.6299 12.2237 19.5663 12.25 19.5 12.25H12.75H12.25V12.75V19.5C12.25 19.5663 12.2237 19.6299 12.1768 19.6768C12.1299 19.7237 12.0663 19.75 12 19.75C11.9337 19.75 11.8701 19.7237 11.8232 19.6768C11.7763 19.6299 11.75 19.5663 11.75 19.5V12.75V12.25H11.25H4.5C4.4337 12.25 4.37011 12.2237 4.32322 12.1768C4.27634 12.1299 4.25 12.0663 4.25 12C4.25 11.9337 4.27634 11.8701 4.32322 11.8232C4.37011 11.7763 4.4337 11.75 4.5 11.75H11.25H11.75V11.25V4.5C11.75 4.4337 11.7763 4.37011 11.8232 4.32322C11.8701 4.27634 11.9337 4.25 12 4.25C12.0663 4.25 12.1299 4.27634 12.1768 4.32322C12.2237 4.37011 12.25 4.4337 12.25 4.5V11.25Z",
    fill: "black",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleMeeting);
export default __webpack_public_path__ + "static/media/ScheduleMeeting.1f4aa40c6e561e78264e03f7fdd81d8e.svg";
export { ForwardRef as ReactComponent };